module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer3_no-inverter-no-pv_lt 1.29c01eb3.svg";